import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const MarquePageHeader = ({ setOpenAddMarque, hasMarqueCreatePermission }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const handleAddMarque = useCallback(() => {
        setOpenAddMarque(true);
    }, [setOpenAddMarque]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Marques")}</Typography>
            </Box>
            {isDesktop && hasMarqueCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddMarque}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addMarqueDialogTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasMarqueCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddMarque} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(MarquePageHeader);